import React from 'react';

interface ToggleListProperties {
  label: string;
  key: string;
  isActive: boolean;
}

interface DurationToggleProperties {
  toggleList: ToggleListProperties[];
  handleClickFunction: (key: string) => void;
}

/**
 * Shared component to toggle between duration
 * @param properties
 * @returns
 */
function DurationToggle(properties: DurationToggleProperties) {
  const { toggleList, handleClickFunction } = properties;
  return (
    <div className="duration-toggle-wrap">
      <div className="duration-toggle-container">
        {toggleList.map((toggle) => (
          <div
            role="presentation"
            className={`each-toggle-list ${toggle.isActive && 'active'}`}
            key={toggle.key}
            onClick={() => handleClickFunction(toggle.key)}>
            {toggle.label}
          </div>
        ))}
      </div>
      {/* Need to implement date selection functionality */}
    </div>
  );
}

export default DurationToggle;
